import { gql } from '@apollo/client'

export const FREE_BUNDLE = gql`
  mutation freeBundle($id: ID!) {
    freeBundle(input: { id: $id }) {
      bundle {
        id
        bundleSchedules {
          id
          status
          audience
          campaign {
            id
            name
          }
          startDate
          endDate
          consumedAt
          freedAt
        }
      }
      errors
    }
  }
`
